define('rebrush/components/captcha/friendly-captcha',[
    'jquery',
    'cartware/components/_base'
], function(
    $,
    Component
) {
    return Component.create({
        $init: function() {
            $('.frc-captcha-solution').each(function() {
                const captchaSolution = $(this);
                const form = captchaSolution.parents('form');
                form.on('submit', function(ev) {
                    if (!ev.defaultPrevented) {
                        const value = form.find('.frc-captcha-solution').val(); // Need to re-query as the node has been replaced
                        if (value && ('' + value).substr(0, 1) === '.') {
                            form.find('.frc-captcha').show();
                            ev.preventDefault();
                            return false;
                        }
                    }
                });
            });
            $('.frc-captcha').hide();
        }
    });
});
